import type { ReactElement } from 'react'

import { useTheme } from '@emotion/react'

import type {
  IconComponent,
  IconProps,
} from '@twistopayments/design-system/icons/constants'
import { ChevronRightIcon } from '@twistopayments/design-system/icons/inline'

import { BaseButton } from '../../atoms/button'
import { Typography } from '../../atoms/typography'

import * as styles from './bubble-banner.styles'

type Props = {
  className?: string
  title: ReactElement | string
  to?: string
  icon?: IconComponent
  iconColor?: IconProps['color']
  onClick?: () => void
  size?: 'small' | 'medium'
  disabled?: boolean
  'data-testid'?: string
  hideChevron?: boolean
  hideArrow?: boolean
}

export const BubbleBanner = ({
  className,
  to,
  icon: Icon,
  iconColor = 'inherit',
  onClick,
  size = 'medium',
  disabled = false,
  title,
  hideChevron = false,
  hideArrow = false,
  ...rest
}: Props) => {
  const theme = useTheme()

  const iconSize = size === 'small' ? '20' : '24'

  return (
    <BaseButton
      className={className}
      css={[styles.button(theme), !disabled && styles.buttonActive(theme)]}
      data-testid="bubble-banner"
      disabled={disabled}
      to={disabled ? undefined : to}
      onClick={disabled ? undefined : onClick}
      {...rest}
    >
      {!hideArrow && (
        <span
          className={styles.ArrowClassName}
          css={styles.arrow(theme, size)}
        ></span>
      )}

      {Icon && <Icon color={iconColor} size={iconSize} />}
      <Typography
        align="start"
        css={styles.text}
        variant={size === 'small' ? 'b4' : 'b3'}
      >
        {title}
      </Typography>

      {!hideChevron && <ChevronRightIcon size={iconSize} />}
    </BaseButton>
  )
}
